import { render, staticRenderFns } from "./WizardPriceTotalPrice.vue?vue&type=template&id=73a0c193"
import script from "./WizardPriceTotalPrice.vue?vue&type=script&lang=js"
export * from "./WizardPriceTotalPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports